const creditCosts = {
    next: 10,
    full: 30,
}

export default creditCosts
